<template>
  <div
    :class="[
      'fixed top-8 right-4 md:top-20 md:right-8 content-wrapper select-none',
      visible ? 'in-animation' : ''
    ]"
  >
    <div :class="['content', visible ? 'zoom' : '']">
      <img src="./assets/block-left.png" class="absolute -left-3 bottom-2 w-8 md:w-10" />
      <img src="./assets/block-right.png" class="absolute -right-3 bottom-8 w-8 md:w-10" />
      <div class="flex-1 absolute left-8 opacity-0 md:opacity-100">
        <img src="./assets/page.png" class="w-20" />
      </div>
      <div
        class="absolute text-xl font-semibold text-white antialiased ml-4 mt-1 opacity-0 md:opacity-100"
      >
        <span>当前分数：</span>
      </div>
      <div class="text-xl font-semibold text-white antialiased truncate ml-0 mb-1 md:ml-36">
        <NumberScroll :number="score.value" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Score } from '@/store/modules/common/types';
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import NumberScroll from '../number-scroll/index.vue';

const userModule = namespace('common');
@Component({
  name: 'Scorecard',
  components: {
    NumberScroll
  }
})
export default class Scorecard extends Vue {
  @userModule.State('score') public score!: Score;

  get visible() {
    return (
      this.score.visible &&
      ['开始', 'start'].includes(this.score.status) &&
      this.score.type === 'single'
    );
  }
}
</script>
<style scoped>
.content-wrapper {
  transform: translateX(150%);
  transition: all 0.5s ease;
}
.content {
  @apply relative flex items-center justify-center w-16 h-16 rounded-full md:w-80 md:h-20 md:rounded-motif;
  background: linear-gradient(89deg, #667fff -3%, #798fff 102%);
  background-size: contain;
  box-shadow: 0px 5px 10px 0px rgb(116 80 245 / 30%);
  transition: all 0.5s ease;
}

.in-animation {
  transform: translateX(0);
  transition: all 0.5s ease;
}

/* 收缩动画  */
/* .zoom {
  @apply w-16 h-16 rounded-full md:w-24 md:h-16 md:rounded-md;
  transition: all 1s ease 3s;
}

.zoom .content-hidden {
  @apply absolute opacity-0;
  transition: all .05s ease 3s;
}

.zoom .value-hidden {
  @apply ml-0 ;
  transition: all 1s ease 3s;
}

.zoom .block-hidden {
  @apply w-8;
  transition: all 1s ease 3s;
} */
</style>
